const getUserMetricsData = state => state?.user?.userMetrics
const getUserListData = state => state?.user?.userList
const getSingleUserData = state => state?.user?.singleUserData

const selectors = {
  getUserMetricsData,
  getUserListData,
  getSingleUserData,
}

export default selectors
